import { render } from "./AdminProvidersModal.vue?vue&type=template&id=70922e61&scoped=true"
import script from "./AdminProvidersModal.vue?vue&type=script&lang=js"
export * from "./AdminProvidersModal.vue?vue&type=script&lang=js"

import "./AdminProvidersModal.vue?vue&type=style&index=0&id=70922e61&scoped=true&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70922e61"]])

export default __exports__